import { render, staticRenderFns } from "./PlusMinusBtn.vue?vue&type=template&id=81d2636e&scoped=true&"
import script from "./PlusMinusBtn.vue?vue&type=script&lang=js&"
export * from "./PlusMinusBtn.vue?vue&type=script&lang=js&"
import style0 from "./PlusMinusBtn.vue?vue&type=style&index=0&id=81d2636e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d2636e",
  null
  
)

export default component.exports